// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.guide[data-v-4fab1ba4]{margin:var(--space-40)}.guide[data-v-4fab1ba4]{color:#000}.guide[data-v-4fab1ba4] a{color:var(--link)}.guide[data-v-4fab1ba4] pre{margin:var(--space-8) 0;padding:var(--space-8) var(--space-16);border:1px solid var(--border);background-color:var(--background-grey);border-radius:var(--border-radius)}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
